import styled from "styled-components";

const HighlightText = styled.mark`
	background-color: var(--highlight-text-background-color);
`;

export default HighlightText;
